export default "__VITE_ASSET__CkXWFLhM__"